import ExamListpage from "@/components/pages/exam-builder/ExamListpage.vue";
import ExamInfoPage from "@/components/pages/exam-builder/ExamInfoPage.vue";
import ExamAttendance from "@/components/pages/exam-attendance/ExamAttendance.vue"

export default [
  {
    path: "exam/build",
    name: "exam.build",
    meta: { access: { menu: "exam", subMenu: "exam-mgmt" } },
    component: ExamListpage,
  },
  {
    path: "exam/build/:quizExamId",
    name: "exam.info",
    meta: { access: { menu: "exam", subMenu: "exam-mgmt" } },
    component: ExamInfoPage,
  },
  {
    path: "exam/attendance",
    name: "exam.attendance",
    meta: { access: { menu: "attendance" } },
    component: ExamAttendance,
  },
];
